export default function AppointmentLocationMap({
  url,
  address,
}: {
  url: string;
  address: string;
}) {
  return (
    <div className="detail-map">
      <a
        href={`https://www.google.de/maps?q=${address}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={url} className="w-full" />
      </a>
    </div>
  );
}
